import { render } from "./LoginSvg.vue?vue&type=template&id=8c5e121c"
import script from "./LoginSvg.vue?vue&type=script&lang=js"
export * from "./LoginSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__